angular.module('unica_room.room_services')

.factory('RoomDeleteService', function ($http, getBaseApiURL) {

	var roomDeleteService = {};

	roomDeleteService.delete = function (roomId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/room/delete/' + roomId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return roomDeleteService;
});